<template>
    <Operations></Operations>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const Operations = defineAsyncComponent(() =>
    import("../../components/Management/Operations/Operations.vue")
);

export default {
    components: { Operations, AuthLayout },
};
</script>
